"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createValidMappedReads = exports.mapKapiReadToDisplay = void 0;
var date_fns_tz_1 = require("date-fns-tz");
var __generated__1 = require("../../../../shared/api/kapi/v1/__generated__/");
var core_1 = require("../../../../shared/core");
var utils_1 = require("../../utils");
var mapKapiToDisplay_1 = require("./mapKapiToDisplay");
//TypeGuards
var isElectricityMeterRead = function (obj) {
    return obj.registers !== undefined;
};
var isGasMeterRead = function (obj) {
    return obj.value !== undefined;
};
var getTiersByRegisters = function (registers) {
    return registers.map(function (register) { return ({
        meterRegisterReading: parseInt(register.value, 10),
        timeOfUseLabel: (0, utils_1.timingCategoryToTimeOfUseLabel)(register.timingCategory),
        registerId: register.registerId,
    }); });
};
var newToLegacyActualAndEstimate = function (reading) {
    if (reading.type === __generated__1.ReadingType.Actual ||
        reading.type === __generated__1.ReadingType.Estimate) {
        return (0, core_1.newToLegacy)(reading.source, reading.type, reading.lifecycle);
    }
};
function mapKapiReadToDisplay(reading, sprn, timezone) {
    if (timezone === void 0) { timezone = 'Europe/London'; }
    var legacyReadingType = newToLegacyActualAndEstimate(reading);
    if (legacyReadingType) {
        var read = {
            sprn: sprn,
            msn: reading.meterSerialNumber,
            formattedReadingDate: (0, date_fns_tz_1.toZonedTime)(reading.dateTime, timezone),
            readingType: legacyReadingType,
        };
        if (isGasMeterRead(reading)) {
            return __assign(__assign({}, read), { tiers: [
                    __assign({ meterRegisterReading: Number(reading.value) }, mapKapiToDisplay_1.dummyGasRegister),
                ], fuel: 'gas' });
        }
        if (isElectricityMeterRead(reading)) {
            return __assign(__assign({}, read), { tiers: getTiersByRegisters(reading.registers), fuel: 'electricity' });
        }
    }
    return null;
}
exports.mapKapiReadToDisplay = mapKapiReadToDisplay;
var filterValidReads = function (read) {
    return read.node.__typename === 'ValidReading';
};
var notNull = function (item) { return !!item; };
var createValidMappedReads = function (asp) {
    return asp.meterReads.edges
        .map(function (read) { return read; })
        .filter(filterValidReads)
        .map(function (edge) {
        return mapKapiReadToDisplay(edge.node.reading, asp.supplyPoint.sprn, asp.supplyPoint.timezone);
    })
        .filter(notNull)
        .sort(utils_1.mostRecentFirst);
};
exports.createValidMappedReads = createValidMappedReads;
